import { z } from 'zod';
import type { ZodObject, ZodString } from 'zod';
import { getLocalizedValidation } from '../i18n/utils';

export function getEmailFormValidationSchema(locale: string): ZodObject<{ email: ZodString }> {
  const { emailValidationMessage } = getLocalizedValidation(locale);

  return z.object({
    email: z
      .string({
        invalid_type_error: emailValidationMessage,
        required_error: emailValidationMessage,
      })
      .email(emailValidationMessage),
  });
}

export function getBookDemoValidationSchema(
  locale: string,
): ZodObject<{ company: ZodString; email: ZodString; firstName: ZodString; lastName: ZodString }> {
  const {
    companyValidationMessage,
    emailValidationMessage,
    firstNameValidationMessage,
    lastNameValidationMessage,
  } = getLocalizedValidation(locale);

  return z.object({
    company: z.string({
      invalid_type_error: companyValidationMessage,
      required_error: companyValidationMessage,
    }),
    email: z
      .string({
        invalid_type_error: emailValidationMessage,
        required_error: emailValidationMessage,
      })
      .email(emailValidationMessage),
    firstName: z.string({
      invalid_type_error: firstNameValidationMessage,
      required_error: firstNameValidationMessage,
    }),
    lastName: z.string({
      invalid_type_error: lastNameValidationMessage,
      required_error: lastNameValidationMessage,
    }),
  });
}

export type TpBookDemoFormSchema = z.infer<ReturnType<typeof getBookDemoValidationSchema>>;
